/* VikingsBrand — Name Forge UI refresh behaviours.
   Additive: vb-names.js and the section's inline boot script are NOT modified.
   Load with defer AFTER the section's own scripts. */
(function () {
  'use strict';

  function init() {
    var root = document.getElementById('vb-name-forge');
    if (!root) return;

    /* ---- 1. hook classes the refresh CSS needs ------------------------------ */
    Array.prototype.forEach.call(root.querySelectorAll('.vb-nf__seg'), function (seg) {
      var field = seg.closest('.vb-nf__field');
      if (field) field.classList.add('vb-nf__field--form');
    });

    /* ---- 2. birthday behind a disclosure ----------------------------------- */
    var day = root.querySelector('#vb-nf-day');
    var dayField = day && day.closest('.vb-nf__field');
    if (dayField && !dayField.dataset.vbCollapsed) {
      dayField.dataset.vbCollapsed = '1';
      dayField.classList.add('vb-nf__field--day');
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'vb-nf__more';
      more.textContent = 'Add a birthday (optional)';
      more.addEventListener('click', function () {
        dayField.classList.add('is-open');
        more.remove();
        day.focus();
      });
      dayField.parentNode.insertBefore(more, dayField.nextSibling);
    }

    /* ---- 2b. public counter ------------------------------------------------ */
    mountCounter(root);

    /* ---- 3. example result, shown before the first generate ---------------- */
    var result = root.querySelector('#vb-nf-result');
    var hasPermalink = /[?&](n|s)=/.test(location.search);
    if (result && !hasPermalink) mountExample(root, result);

    /* ---- 4. "Have this name engraved" copies the name, then opens the collection */
    var engrave = root.querySelector('.vb-nf__next a[href*="/collections/"]');
    if (engrave) {
      promoteEngrave(root, engrave);
      var label = engrave.textContent;
      engrave.addEventListener('click', function (e) {
        var cur = window.VBNames && window.VBNames.getCurrent && window.VBNames.getCurrent();
        if (!cur || !cur.full) return; /* nothing generated yet — just navigate */
        e.preventDefault();
        var name = cur.full;
        try { sessionStorage.setItem('vb:engraving', name); } catch (err) {}
        var done = function () {
          engrave.textContent = 'Copied \u201C' + name + '\u201D, opening engravable blades\u2026';
          engrave.classList.add('is-copied');
          var live = root.querySelector('#vb-nf-live');
          if (live) live.textContent = name + ' copied to your clipboard.';
          setTimeout(function () {
            engrave.textContent = label;
            engrave.classList.remove('is-copied');
            window.location.href = engrave.getAttribute('href');
          }, 1100);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(name).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = name; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.top = '-1000px';
          document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (err) {}
          ta.remove();
          done();
        }
      });
    }
  }

  /* Lifts the engraving link out of the three-equal-links row into its own card.
     The link element is MOVED, not cloned or rebuilt: the copy-then-navigate
     listener is attached to this exact node, and its .is-copied confirmation
     writes to it, so recreating it would silently kill both. Runs before the
     listener is attached, but appendChild would preserve it either way. */
  function promoteEngrave(root, link) {
    var next = link.closest('.vb-nf__next');
    if (!next || root.querySelector('.vb-nf__engrave')) return;

    var card = document.createElement('div');
    card.className = 'vb-nf__engrave';
    card.innerHTML =
      '<div class="vb-nf__engrave-body">' +
        '<span class="vb-nf__engrave-eyebrow">Carry the name</span>' +
        '<p class="vb-nf__engrave-title">Have your name engraved on a blade</p>' +
        '<p class="vb-nf__engrave-note">Laser-engraved on the flat of a functional ' +
        'carbon-steel blade, in Latin letters or runes.</p>' +
      '</div>';

    link.textContent = 'Engrave this name →';
    link.className = 'vb-nf__engrave-cta';
    card.appendChild(link);
    next.parentNode.insertBefore(card, next);
  }

  /* Public "names forged" counter, backed by the Cloudflare Worker in
     data-counter. Entirely dormant when that attribute is empty: no element shown,
     no request made. The number rendered is always whatever the store returns —
     never seeded, never extrapolated from a clock. See the note in the section.

     Increments hang off the 'vb:name-action' event that vbTrack emits, so the counter
     sees exactly what analytics sees — including downloads and shares, which call
     vbTrack internally and would bypass a wrapper on the exported track(). The
     example card never calls track, so it is never counted. */
  function mountCounter(root) {
    var api = (root.getAttribute('data-counter') || '').replace(/\/+$/, '');
    var node = root.querySelector('#vb-nf-count');
    if (!api || !node) return;

    /* Below the floor the count is tracked but not shown — see the section comment. */
    var min = parseInt(root.getAttribute('data-counter-min'), 10);
    if (!isFinite(min) || min < 0) min = 0;

    var shown = null;
    var numEl = null;
    function paint(n) {
      if (typeof n !== 'number' || !isFinite(n) || n <= 0) return;
      shown = n;
      if (n < min) { node.hidden = true; return; }
      /* Built once, then only the figure is rewritten, so an increment does not
         re-lay out the row. Structure mirrors the approved design: accent dot,
         the number as the hero, label stacked small beside it. */
      if (!numEl) {
        node.innerHTML =
          '<span class="vb-nf__count-dot" aria-hidden="true"></span>' +
          '<span class="vb-nf__count-num"></span>' +
          '<span class="vb-nf__count-label">names forged<br>from the sagas</span>';
        numEl = node.querySelector('.vb-nf__count-num');
      }
      /* The heading serif draws a heavy, low-sitting comma that punches a hole in
         the figure. Isolating the separator lets CSS quiet it without changing the
         grouping, which stays the en-US comma the audience expects. Built from a
         formatted Number, so there is nothing user-supplied in this markup. */
      numEl.innerHTML = n.toLocaleString('en-US')
        .replace(/,/g, '<span class="vb-nf__count-sep">,</span>');
      node.hidden = false;
    }
    function read(body) {
      try { return (body && typeof body.generate === 'number') ? body.generate : null; }
      catch (e) { return null; }
    }

    fetch(api, { method: 'GET' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (b) { paint(read(b)); })
      .catch(function () {});

    document.addEventListener('vb:name-action', function (e) {
      var action = e.detail && e.detail.vb_action;
      var key = (action === 'generate' || action === 'again') ? 'generate'
              : (action === 'download') ? 'download' : null;
      if (!key) return;
      /* optimistic local bump so the number moves with the click even if the
         round trip is slow; the next response overwrites it with the truth */
      if (key === 'generate' && shown !== null) paint(shown + 1);
      fetch(api + '?k=' + key, { method: 'POST', keepalive: true })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (b) { var n = read(b); if (n !== null) paint(n); })
        .catch(function () {});
    });
  }

  /* Renders a sample card in the real result node so the visitor sees the payoff
     before interacting. Removed the moment a real result is shown. */
  function mountExample(root, result) {
    var tries = 0;
    (function wait() {
      var V = window.VBNames;
      var res = null;
      try {
        res = V && V.generate ? V.generate({ mode: 'forge', gender: 'f', seed: 'vikingsbrand', withByname: true }) : null;
      } catch (err) { res = null; }
      if (!res) {
        if (tries++ < 60) return setTimeout(wait, 100);
        return;
      }
      if (!result.hidden) return; /* a real result beat us to it */

      set(root, '#vb-nf-eyebrow', 'Example result');
      set(root, '#vb-nf-full', res.full);
      set(root, '#vb-nf-runes', res.runes);
      html(root, '#vb-nf-g1', '<b>' + esc(res.given.on) + '</b>: ' + esc(res.given.meaning));
      if (res.byname) {
        html(root, '#vb-nf-g2', '<b>' + esc(res.byname.on) + '</b>: ' + esc(res.byname.meaning));
        set(root, '#vb-nf-bearer', 'borne by ' + res.byname.bearer);
      }
      result.setAttribute('data-example', '');
      result.hidden = false;

      var obs = new MutationObserver(function () {
        if (!result.hasAttribute('data-example')) return;
        /* the section's own show() writes the name node; once it differs, hand over */
        var full = root.querySelector('#vb-nf-full');
        if (full && full.textContent && full.textContent !== res.full) {
          result.removeAttribute('data-example');
          obs.disconnect();
        }
      });
      obs.observe(result, { subtree: true, childList: true, characterData: true });
    })();
  }

  function set(root, sel, text) { var n = root.querySelector(sel); if (n) n.textContent = text; }
  function html(root, sel, markup) { var n = root.querySelector(sel); if (n) { n.innerHTML = markup; n.hidden = false; } }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  } else { setTimeout(init, 0); }
})();
